const normalizedBasePath = normalizeBasePath(import.meta.env.BASE_URL);

function normalizeBasePath(baseUrl: string) {
  const pathname = new URL(baseUrl || "/", "https://example.local").pathname;
  const normalized = pathname.replace(/\/+$/, "");
  return normalized === "/" ? "" : normalized;
}

export function stripAppBasePath(pathname: string) {
  const path = pathname || "/";
  if (!normalizedBasePath) return path;

  const lowerPath = path.toLowerCase();
  const lowerBasePath = normalizedBasePath.toLowerCase();
  if (lowerPath === lowerBasePath) return "/";
  if (lowerPath.startsWith(`${lowerBasePath}/`)) {
    return path.slice(normalizedBasePath.length) || "/";
  }
  return path;
}

export function withAppBasePath(path: string) {
  if (!path.startsWith("/") || !normalizedBasePath) return path;
  if (path === "/") return `${normalizedBasePath}/`;
  if (path.toLowerCase().startsWith(`${normalizedBasePath.toLowerCase()}/`)) return path;
  return `${normalizedBasePath}${path}`;
}
